/** Consistent required-field styling (red asterisk) for MUI forms. */
export const REQUIRED_ASTERISK_SX = {
  "& .MuiFormLabel-asterisk": {
    color: "error.main",
  },
};

export const requiredInputLabelProps = {
  required: true,
  sx: REQUIRED_ASTERISK_SX,
};

/** Strip manual " *" suffix so MUI renders the required asterisk. */
export function stripManualRequiredAsterisk(label) {
  return String(label || "").replace(/\s*\*+\s*$/, "").trim();
}

export function requiredTextFieldProps(label) {
  return {
    required: true,
    label: stripManualRequiredAsterisk(label),
    InputLabelProps: requiredInputLabelProps,
  };
}

export function requiredFormControlLabelProps(label) {
  return {
    required: true,
    sx: REQUIRED_ASTERISK_SX,
    children: stripManualRequiredAsterisk(label),
  };
}
